/* Shopify's recommendations arrive from their own endpoint after load, so the
   PDP is not held up waiting for them. */
(() => {
  'use strict';
  const host = document.getElementById('related-section');
  if (!host || !host.dataset.url) return;

  fetch(host.dataset.url)
    .then(r => (r.ok ? r.text() : null))
    .then(html => {
      if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('related-section');
      if (fresh && fresh.innerHTML.trim()) {
        host.innerHTML = fresh.innerHTML;
        if (window.hyraPaintHearts) window.hyraPaintHearts();
      }
    })
    .catch(() => {});
})();
